module.exports = {
	"context": {
		"name": "Context",
		"type": "select",
		"default": "offline",
		"options": [
			{
				"key": "offline",
				"name": "Offline"
			},
			{
				"key": "realtime",
				"name": "Realtime"
			}
		]
	},
	"workflow": {
		"name": "Workflow",
		"type": "select",
		"default": "metalness",
		"options": [
			{
				"key": "metalness",
				"name": "Metalness"
			},
			{
				"key": "specular",
				"name": "Specular"
			}
		]
	},
	"microsurface": {
		"name": "Microsurface",
		"type": "select",
		"default": "roughness",
		"options": [
			{
				"key": "roughness",
				"name": "Roughness"
			},
			{
				"key": "gloss",
				"name": "Gloss"
			}
		]
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings/2d.json
// module id = 2483
// module chunks = 0